import { CoreRankings } from '../../models';

/**
 * This is RankingsTipping Model Class
 */
export class Rankings extends CoreRankings {
	get defaults() {
		return {
			rounds:       {},
			squads:       {},
			actual_round: 0,
			states:       {
				"1": "ACT",
				"2": "NT",
				"3": "NSW",
				"4": "QLD",
				"5": "SA",
				"6": "TAS",
				"7": "VIC",
				"8": "WA"
			},
			round:        0,
			overall_rank: '-',

			margin:       '-',
			points:       '-',
			prev_rank:    '-',
			round_rank:   '-',
			total_margin: '-',
			total_points: '-',
			user_id:      0,
			club:         '',
			offset:       0,
			state:        ''
		};
	}
}

export default Rankings;